import React from 'react';
import CustomPage from '../../components/CustomPage';

const ChangeBrowser = () => <CustomPage title="t.unsupported_browser.title" description="t.unsupported_browser.text" />;

export default ChangeBrowser;
